

































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { TrainingCategoryDataModule } from '@/app/store/modules/trainingCategory'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'

@Component({
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  // Property Global
  private selected = []
  public get isLoading() {
    return TrainingCategoryDataModule.isLoading
  }
  public get page() {
    return TrainingCategoryDataModule.Pages
  }
  public get limit() {
    return TrainingCategoryDataModule.Limit
  }
  public created() {
    this.getImage()
    this.getData()
  }
  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }
  public getData() {
    TrainingCategoryDataModule.getTrainingCategoryData()
  }
  public get trainingCategoryData() {
    return TrainingCategoryDataModule.trainingCategoryData
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }

  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    //  console.log('Panggil action get with query search', item)
  }

  public fields = [
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'totalFiles', sortable: false },
    { key: 'isActive', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]

  // Property Pagination
  private onPageNumChanged(limit: any) {
    TrainingCategoryDataModule.paginationParam.paging.limit = limit
    this.getData()
  }
  private funcFirstPage() {
    TrainingCategoryDataModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    TrainingCategoryDataModule.paginationParam.paging.page =
      TrainingCategoryDataModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    TrainingCategoryDataModule.paginationParam.paging.page =
      TrainingCategoryDataModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    TrainingCategoryDataModule.paginationParam.paging.page =
      (this.trainingCategoryData.pagination &&
        this.trainingCategoryData.pagination.pageCount) ||
      0
    this.getData()
  }

  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
